<template>
  <v-app  v-if="loggedInUserID != null" class="bckcolor">
    <div class="fixed-top">
        <b-navbar toggleable="lg" type="light" variant="light" style="height:auto;">  
       <b-navbar-brand><img src="../../assets/headlogo.png" style="width:200px;cursor: pointer;" @click="main()"/></b-navbar-brand>
       
       <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

       <b-collapse id="nav-collapse" is-nav>
         <b-navbar-nav>
         </b-navbar-nav>

         <b-navbar-nav class="ml-auto mr-5">
           <b-nav-item @click="myHome()" style="font-weight:bold;">
             Home
           </b-nav-item>
           <b-nav-item @click="myAbout()" style="font-weight:bold;">
             About Us
           </b-nav-item>
           <b-nav-item @click="myProduct()" style="font-weight:bold;">
             Products
           </b-nav-item>
           <b-nav-item @click="myEnquiry()" style="font-weight:bold;">
             Enquiry
           </b-nav-item>
           <b-nav-item @click="nyContact()" style="font-weight:bold;">
             Contact Us
           </b-nav-item>
           <b-nav-item @click="myCertificate()" style="font-weight:bold;">
             CE Certificatioin
           </b-nav-item>
           <b-nav-item @click="myTrade()" style="font-weight:bold;">
             Trademark
           </b-nav-item>
           <b-nav-item @click="myPrint()" style="font-weight:bold;">
             Imprint
           </b-nav-item>
           <b-nav-item @click="myEvent()" style="font-weight:bold;">
             News & Events
           </b-nav-item>
           <b-nav-item v-if="loggedInUserID != null" style="font-weight:bold;">
            <h6 @click.stop="logOutDialog = true" style="margin-top:2px;font-weight:bold;color:#E31E24">Logout</h6>
            

              <v-dialog v-model="logOutDialog" max-width="290" persistent>
                <v-card style="padding: 20px !important ; border-radius: 0px;border:1px solid;">
                  <v-sheet color="transparent" style="text-align:center">
                    <v-icon color="#0d47a1" :size="40">https</v-icon>
                  </v-sheet>
                  
                  <h3 style="text-align:center;font-size:20px;color:red">Logout</h3>

                  <v-card-text style="text-align:center;color:black">Are you sure you want to logout</v-card-text>

                  
                    <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>
                    <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
                </v-card>
              </v-dialog>
           </b-nav-item>
           </b-navbar-nav>
       </b-collapse>
     </b-navbar>
    </div>


    <div style="padding-top:100px">
        <v-layout row wrap style="padding:25px">
          <v-flex xs12>
            <h2 style="text-align:center;font-weight:bold;padding-bottom:20px">CE CERTIFICATION</h2>
          </v-flex>
            <v-flex xs12 sm12 md3 style="padding:5px">
              <a href="https://api.l2mtech.de/api/Pdf/1" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">FlexiTrack 018</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/2" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">FlexiTrack 035</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/3" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">PearlFlow NS</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/4" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">LimusTrack</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/5" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">LimusTrack</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/6" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">LomiFlow</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/7" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">LomiFlow</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/8" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">PearlFlow</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/9" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">PearlFlow</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/10" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">GmbH Cert.</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>

        <v-flex xs12 sm12 md3 style="padding:5px">
          <a href="https://api.l2mtech.de/api/Pdf/11" target="_bank" class="txt_dec">
            <v-card class="txt_dec" flat style="cursor: pointer;padding: 0px">
              <v-card-title style="padding:0px;border:1px solid;border-color:grey">
                        <h4 style="color:black;text-align:right;padding:10px">IQNet Cert.</h4>
                        <v-spacer></v-spacer>
                   <v-card style="background-color:#e31e24;shadow: none;border-radius:0px">
                  <v-icon color="white" style="padding-bottom:5px" :size="40">picture_as_pdf</v-icon>
                </v-card>     
              </v-card-title>
          </v-card>
          </a>
        </v-flex>
        </v-layout>
    </div>
  </v-app>
</template>

<script>
import Avatar from "vue-avatar";
import config from "./../../config.json";
//import vuetifyToast from "vuetify-toast";
//import { AuthStr } from "../Auth.js";
/* import carousel from 'vue-owl-carousel'; */
const DEFAULT_TRANSITION = "fade";
export default {
  components: {
    Avatar
  },
  data() {
    return {
      tab: null,
      valid: true,
      passwordShow: false,
      menu: false,
      darkMode: false,
      dateModel: false,
      enquiryDialog: false,
      logOutDialog: false,
      loggedInUserName: sessionStorage.loggedInUserName,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,
      transitionName: DEFAULT_TRANSITION,
      isLoading: false,
      destinations: null,
      selectedDestination: null,
      logDialog: false,
      btnSave: false,
      src: "https://aimroindia.com/aimro/api/ProfilePic/" + sessionStorage.loggedInUserID,

      homeB: true,
      aboutB: false,
      activityB: false,
      centreB: false,
      teacherB: false,
      partnerB: false,

      form: {
        email: null
      },

      categoryList: [],

      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        emailid: value => {
          const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Email Id is not valid!!";
        },
      },

    };
  },
  methods: {
    myHome: function () {   
          window.open("https://www.l2mtech.de/", "_blank");    
      },
      myAbout: function () {   
          window.open("https://www.l2mtech.de/about-us/", "_blank");    
      },
      myProduct: function () {   
          window.open("https://www.l2mtech.de/#", "_blank");    
      },
      myEnquiry: function () {   
          window.open("https://www.l2mtech.de/enquiry/", "_blank");    
      },
      myContact: function () {   
          window.open("https://www.l2mtech.de/contact-us/", "_blank");    
      },
      /* myCertificate: function () {   
          window.open("https://www.l2mtech.de/ce-certification/", "_blank");    
      }, */
      myTrade: function () {   
          window.open("https://www.l2mtech.de/trademark/", "_blank");    
      },
      myPrint: function () {   
          window.open("https://www.l2mtech.de/imprint/", "_blank");    
      },
      myEvent: function () {   
          window.open("https://www.l2mtech.de/news-events/", "_blank");    
      },

      1: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/1", "_blank");    
      },
      2: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/2", "_blank");    
      },
      3: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/3", "_blank");    
      },
      4: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/4", "_blank");    
      },
      5: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/5", "_blank");    
      },
      6: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/6", "_blank");    
      },
      7: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/7", "_blank");    
      },
      8: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/8", "_blank");    
      },
      9: function () {   
          window.open("https://docs.l2mtech.de/api/api/Pdf/9", "_blank");    
      },
      
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.prevHeight = getComputedStyle(element).height;
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/wanderlusters");
        window.location.reload();
      });
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    
    login() {
      this.$router.push("/login");
    },
    cartList() {
      this.$router.push("/cartList");
    },

    dashboard() {
      this.$router.push("/_");
    },

    vendor() {
      this.$router.push("/vendorRegistration");
    },

    register() {
      this.$router.push("/registration");
    },

    home() {
      this.$router.push("/wings");
      this.aboutB = false;
      this.activityB = false;
      this.centreB = false;
      this.teacherB = false;
      this.partnerB = false;
      this.homeB = true;
    },

    about() {
      this.$router.push("/aboutus");
      this.homeB = false;
      this.activityB = false;
      this.centreB = false;
      this.teacherB = false;
      this.partnerB = false;
      this.aboutB = true;
    },

  },

  mounted() {
    this.axios
        .get(config.API + "MenuCategories", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categoryList = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
  },

  created() {

    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Special+Elite&display=swap');
@import url('https://fonts.googleapis.com/css?family=Farro&display=swap');  
@keyframes blink {
  from { background-color: purple; }
  to { background-color: red; }
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
.header-top {
    background-color: green;
    color: #fff;
    width: 100%;
    padding: 6px;
    /* margin-bottom: 5px; */
}
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.ss {
  border-radius: 5%;
  height: 60px !important;
}
.ss1 {
  border-radius: 5%;
  height: 58px !important;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.near {
  top: -70px;
  position: relative;
}
.near1 {
  top: -70px;
  bottom: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 70px;
}
.pdng {
  padding-bottom: -25px !important;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.menutxt {
  padding-right: 10px;
  font-family: 'Special Elite', cursive;
  font-weight: bold;
  font-size: 17px;
  text-align: center;
  margin-bottom: 0px;
}
.footertxt {
  font-family: 'Nanum Gothic', sans-serif;
  color: white !important;
  font-size: 16px;
}
.hq {
  border-style: solid;
    border-width: 1px;
    border-radius: .5rem;
    margin-left: .5rem;
    padding: .125rem .5rem;
    font-size: 12px !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.hotel_name1 {
  font-family: 'Anton', sans-serif;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #fff !important;
  border-bottom: none !important;
}
td.hvr:hover {
  background-color: #fff !important;
  background: #fff !important;
  border-bottom: none !important;
}
.rate {
  height: 280px;
  border-radius: 4%;
  background-image: linear-gradient(#7b1fa2, #e91e63);
 /* background-color: #eeeeee; */
}
.yellowText {
    color: yellow;
}
.font12 {
    font-size: 12px;
    line-height: 12px;
}
.latoBold {
    font-weight: 700;
}
.sprite.discountIcon {
    width: 38px;
    height: 17px;
    background-position: -206px -73px;
}
.appendLeft5 {
    margin-left: 5px;
}
.sprite {
    background: url(//imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/web/hotelSprite-v4.png) no-repeat;
    display: inline-block;
    background-size: 400px 400px;
    font-size: 0px;
    flex-shrink: 0;
}
.font11 {
    font-size: 11px;
    line-height: 11px;
}
.discountText {
    display: inline-block;
    position: absolute;
    left: 12px;
    top: 2px;
}
.lineThrough {
  text-decoration: line-through;
}
.filtr {
  background-image: linear-gradient(#e91e63, #7b1fa2);
}
.aminity {
  width: 100%;
}
.aminities {
  width: 30%;
  float: left;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.sign {
  color:white !important;
}
tr {
  border-bottom: none !important;
}
.form-container {
  margin: 0px !important;
}
.flashing_effect {
  background-image: linear-gradient(-90deg, #f44336, #b32e25);
  padding: 12px 15px;
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
@media screen and (max-width: 768px) {
  .heading_1 {
    font-size: 14px;
  }
  .rspnsv {
    margin-bottom: 30px;
    height: auto;
  }
  ._hello {
    height: auto !important;
  }
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
.abc {
  overflow: hidden !important;
}
.ftr {
  /* background-image: url('../../assets/footer.png'); */
  background-color: #333333;
  background-size: cover !important;
}
.txt_dec:hover {
    text-decoration: none !important;
}
.bckcolor {
    position: relative;
    background-color: #ffffff;
    background-image: linear-gradient( 36deg, #fff 0%, #d7e1ec 74%);
    box-shadow: inset 0 2px 5px 0px rgb(0 0 0 / 39%);
}
</style>
